export default __webpack_public_path__ + "static/Entenda0058-622bfa64685d27b40a1d3d30e2933f15.jpg";